import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M21 12.055C21 7.054 16.97 3 12.001 3 7.03 3.001 3 7.054 3 12.056c0 4.519 3.291 8.265 7.593 8.944v-6.327H8.309v-2.617h2.286V10.06c0-2.27 1.344-3.522 3.4-3.522.985 0 2.014.176 2.014.176v2.228h-1.135c-1.117 0-1.466.698-1.466 1.415v1.698h2.495l-.398 2.617h-2.098v6.327C17.71 20.319 21 16.574 21 12.055Z"
    />
  </svg>
`;
